import { takeEvery, call, put, select } from 'redux-saga/effects';
import { yaGoal } from 'mt-react-common/utils/Analytics';

import {
  sendRequest,
  requestInProcess,
  requestFinished,
  setErrors,
  selectFormBody,
  clearAllErrors,
  initState
} from '../../../../common/reducers/execReportForm';
import { timeoutCall } from '../../../../../../utils/sagaHalper';
import TasksExecsService from '../../../../services/TasksExecsService';
import * as clientNoticesActions from '../../../../../main/reducers/static/states/clientNotices/reducer';
import { deleteGroupItems } from '../../../../../../common/reducers/listsCollection/reducer';
import { dataRequest } from '../../../../../../common/reducers/objectCollection/reducer';
import { sendGetAuthAccountDataRequest } from '../../../../../users/common/reducers/states/authAccount';

function* execReportFormSaga(reducerName, action) {
  const formBody = yield select(selectFormBody, reducerName);
  yield put(requestInProcess(reducerName));
  try {
    yield put(clearAllErrors(reducerName));

    const result = yield call(
      timeoutCall,
      TasksExecsService.sendReport,
      action.payload,
      formBody
    );
    if (result) {
      if (result.status === 422) {
        yield put(setErrors(reducerName, result.data));
      } else if (result.status === 200) {
        yield put(initState(reducerName));
        yield put(sendGetAuthAccountDataRequest());
        yield put(
          deleteGroupItems(
            'tasksModule.collections.tasksExecsNotSendMaterialsCollection',
            action.payload
          )
        );
        yield put(
          dataRequest(
            'tasksModule.collections.tasksExecsCollection',
            action.payload
          )
        );
        yield put(
          clientNoticesActions.addClientNotice({
            type: 'success',
            message: result.data.message
          })
        );
        yaGoal('reportTaskExec');
      }
    }
    yield put(
      requestFinished(reducerName, result.status, result.status === 200)
    );
  } catch (error) {
    yield put(requestFinished(reducerName));
  }
  yield put(requestFinished(reducerName));
}

export default function getSaga(reducerName) {
  return [
    takeEvery(sendRequest(reducerName).type, execReportFormSaga, reducerName)
  ];
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/reducers/static/forms/sagas/execReportFormSaga.js